import { useEffect, useRef, useState } from "react";

// Returns [ref, progress 0..1] describing how far the element has travelled
// through the viewport. Scroll-linked (user driven), rAF throttled, passive.
export default function useScrollProgress() {
  const ref = useRef(null);
  const [p, setP] = useState(0);

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;
    let raf = 0;
    const calc = () => {
      raf = 0;
      const r = node.getBoundingClientRect();
      const vh = window.innerHeight || 800;
      // Progress of the viewport's centre line through the block, so the rail
      // always matches the beat the visitor is actually reading.
      const next = Math.min(1, Math.max(0, (vh * 0.5 - r.top) / Math.max(1, r.height)));
      setP((prev) => (Math.abs(prev - next) < 0.003 ? prev : next));
    };
    const onScroll = () => { if (!raf) raf = requestAnimationFrame(calc); };
    calc();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return [ref, p];
}
